import React, { useEffect, createElement } from 'react';
import { MatrixRain } from './components/MatrixRain';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Divider } from './components/Divider';
import { Revelation } from './components/Revelation';
import { PainPoints } from './components/PainPoints';
import { Arsenal } from './components/Arsenal';
import { TransformTable } from './components/TransformTable';
import { Modules } from './components/Modules';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '1678416013150727');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full flex flex-col relative" data-id="element-0">
      <MatrixRain data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <Navbar data-id="element-3" />
      <main className="relative z-10" data-id="element-4">
        <Hero data-id="element-5" />
        <Divider data-id="element-6" />
        <Revelation data-id="element-7" />
        <Divider data-id="element-8" />
        <PainPoints data-id="element-9" />
        <Divider data-id="element-10" />
        <Arsenal data-id="element-11" />
        <Divider data-id="element-12" />
        <TransformTable data-id="element-13" />
        <Divider data-id="element-14" />
        <Modules data-id="element-15" />
        <Divider data-id="element-16" />
        <Offer data-id="element-17" />
        <Divider data-id="element-18" />
        <Testimonials data-id="element-19" />
        <Divider data-id="element-20" />
        <Guarantee data-id="element-21" />
        <FAQ data-id="element-22" />
        <Divider data-id="element-23" />
        <FinalCTA data-id="element-24" />
      </main>
      <Footer data-id="element-25" />
    </div>;
}